import script from "./UserNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNotifications.vue?vue&type=script&setup=true&lang=js"

import "./UserNotifications.vue?vue&type=style&index=0&id=1a0d9888&lang=scss"

const __exports__ = script;

export default __exports__